import { Loader2, CheckCircle2, Clock } from 'lucide-react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Badge } from '@/components/ui/badge'
import { useUserWatchedEpisodes } from '@/services/admin/users.service'

interface UserWatchedEpisodesProps {
  userId: string
}

export function UserWatchedEpisodes({ userId }: UserWatchedEpisodesProps) {
  const { data: episodes, isLoading } = useUserWatchedEpisodes(userId)

  const formatDate = (dateString: string) =>
    new Date(dateString).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })

  const formatDuration = (seconds: number | null | undefined) => {
    // Trata valores inválidos
    if (seconds == null || isNaN(seconds) || seconds < 0) {
      return '0m 0s'
    }

    const mins = Math.floor(seconds / 60)
    const secs = Math.floor(seconds % 60)
    return `${mins}m ${secs}s`
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    )
  }

  const completedEpisodes = episodes?.filter((ep) => ep.completed) || []

  if (completedEpisodes.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        <p>🎬 Nenhuma aula assistida até o fim</p>
      </div>
    )
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Aula</TableHead>
          <TableHead>Módulo</TableHead>
          <TableHead>Tempo assistido</TableHead>
          <TableHead>Assistido em</TableHead>
          <TableHead>Status</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {completedEpisodes.map((episode) => (
          <TableRow key={episode.episodeId}>
            <TableCell className="font-medium">{episode.episodeTitle}</TableCell>
            <TableCell className="text-muted-foreground">{episode.moduleTitle}</TableCell>
            <TableCell>
              <div className="flex items-center gap-1">
                <Clock className="h-3 w-3 text-muted-foreground" />
                {formatDuration(episode.watchTime)}
              </div>
            </TableCell>
            <TableCell className="text-sm">{formatDate(episode.lastWatchedAt)}</TableCell>
            <TableCell>
              <Badge variant="default" className="gap-1">
                <CheckCircle2 className="h-3 w-3" />
                Concluída
              </Badge>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
